import { QuestionOutlineIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Heading,
  HStack,
  Input,
  Stack,
  StackDivider,
  Text,
  Textarea,
  Tooltip,
  useToast,
  VStack
} from '@chakra-ui/react';
import axios from 'axios';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { UploadIcon } from '../../../../assets/icons/UploadIcon';
import { WhiteLabelWrapper } from '../../../../components/layouts/WhiteLabelWrapper';
import { WhiteLabelNavigator } from '../../../../components/navigation/WhiteLabelNavigator';
import { BoxCritical } from '../../../../components/white-label/BoxCritical';
import {
  ModalImages,
  ModalSelectImage
} from '../../../../components/white-label/modals/ModalSelectImage';
import { SocialMediaRow } from '../../../../components/white-label/SocialMediasRow';
import { WhiteLabelSteps } from '../../../../components/white-label/WhiteLabelSteps';
import { StepsFormActions } from '../../../../contexts/StepsContext';
import { useStepsForm } from '../../../../hooks/useStepsForm';
import { apiSensedia } from '../../../../services/api-sensedia';
import { listAllImages } from '../../../../services/white-label/storage.service';

let apiWl = apiSensedia;

if (process.env.NODE_ENV != 'development') {
  apiWl = apiSensedia;
}

export const StepFour = (): JSX.Element => {
  const { state, setState } = useStepsForm();

  const { idWebsite } = useParams();

  const fieldsInputRefTitle = useRef() as MutableRefObject<HTMLTextAreaElement>;
  const fieldsInputRefSubtitle =
    useRef() as MutableRefObject<HTMLTextAreaElement>;
  const fieldsInputRefBanner = useRef() as MutableRefObject<HTMLDivElement>;
  const linkInputFacebook = useRef() as MutableRefObject<HTMLInputElement>;
  const linkInputInstagram = useRef() as MutableRefObject<HTMLInputElement>;
  const linkInputTwitter = useRef() as MutableRefObject<HTMLInputElement>;
  const linkInputYoutube = useRef() as MutableRefObject<HTMLInputElement>;
  const linkInputLinkedin = useRef() as MutableRefObject<HTMLInputElement>;

  const [criticalGecad, setCriticalGecad] = useState({
    IMAGEM_SECAO_2: '',
    TITULO_SECAO_2: '',
    SUBTITULO_SECAO_2: '',
    FACEBOOK: '',
    TWITTER: '',
    INSTAGRAM: '',
    YOUTUBE: '',
    LINKEDIN: ''
  });

  const [, setNameImgBannerFour] = useState<FileList | null | string>();

  // const [isDragBannerFour, setIsDragBannerFour] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [descriptionTitleLength, setDescriptionTitleLength] = useState(0);
  const [descriptionSubTitleLength, setdescriptionSubTitleLength] = useState(0);
  const [corretorImages, setCorretorImages] = useState<ModalImages[]>([]);

  const hasBanner =
    state.selectedFileBannerFour || state.selectedFileBannerFourName;

  const toast = useToast();
  const navigate = useNavigate();

  const getCriticalGecad = async () => {
    try {
      //const res = await axios.get(`/${idWebsite}`);
      //setCriticalGecad(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleModalSelectImage = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleGetWebsite = async () => {
    try {
      const res = await apiWl.get(`/websites/${idWebsite}`);

      setState({
        type: StepsFormActions.setSelectedFileBannerFour,
        payload: res.data.banner_second_sec_url
      });
      setState({
        type: StepsFormActions.setSelectedFileBannerFourName,
        payload: res.data.banner_second_sec
      });
      setState({
        type: StepsFormActions.setCompanyTitleFour,
        payload: res.data.description_second_sec_title
      });
      setState({
        type: StepsFormActions.setCompanySubtitleFour,
        payload: res.data.description_second_sec_subtitle
      });
      setState({
        type: StepsFormActions.setProfileFacebook,
        payload: res.data.facebook
      });
      setState({
        type: StepsFormActions.setProfileTwitter,
        payload: res.data.twitter
      });
      setState({
        type: StepsFormActions.setProfileInstagram,
        payload: res.data.instagram
      });
      setState({
        type: StepsFormActions.setProfileYoutube,
        payload: res.data.youtube
      });
      setState({
        type: StepsFormActions.setProfileLinkedin,
        payload: res.data.linkedin
      });
      const objetoCritica = {
        IMAGEM_SECAO_2:
          res.data.ultimaCritica.parametros_website.param_imagem_secao_2 || '',
        TITULO_SECAO_2:
          res.data.ultimaCritica.parametros_website.param_titulo_secao_2 || '',
        SUBTITULO_SECAO_2:
          res.data.ultimaCritica.parametros_website.param_subtitulo_secao_2 ||
          '',
        FACEBOOK:
          res.data.ultimaCritica.parametros_website.param_facebook || '',
        TWITTER: res.data.ultimaCritica.parametros_website.param_twitter || '',
        INSTAGRAM:
          res.data.ultimaCritica.parametros_website.param_instagram || '',
        YOUTUBE: res.data.ultimaCritica.parametros_website.param_youtube || '',
        LINKEDIN: res.data.ultimaCritica.parametros_website.param_linkedin || ''
      };
      setCriticalGecad({ ...objetoCritica });
    } catch (error) {
      console.log(error);
    }
  };

  const handlePutWebsite = async () => {
    try {
      const body = {
        banner_second_sec: state.selectedFileBannerFourName,
        description_second_sec_title: state.companyTitleFour,
        description_second_sec_subtitle: state.companySubtitleFour,
        facebook: state.profileFacebook,
        twitter: state.profileTwitter,
        instagram: state.profileInstagram,
        youtube: state.profileYoutube,
        linkedin: state.profileLinkedin,
        contains_sulamerica_logo: state.logoSulamerica
      };
      await apiWl.put(`/websites/${idWebsite}`, body);
      await apiWl.put(`/websites/${idWebsite}/conclusao`, {});
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeBannerFour = (e: any) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);

    setState({
      type: StepsFormActions.setSelectedFileBannerFour,
      payload: url
    });
  };

  const handleImageSelectedGalleryBannerFour = (
    currentSelectedImage: any,
    fileNameForUrl: any
  ) => {
    const file = fileNameForUrl;
    setNameImgBannerFour(currentSelectedImage);
    setState({
      type: StepsFormActions.setSelectedFileBannerFour,
      payload: file
    });
    setState({
      type: StepsFormActions.setSelectedFileBannerFourName,
      payload: currentSelectedImage
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const bannerDivElement = fieldsInputRefBanner.current;
    const bannerBackgroundImage =
      window.getComputedStyle(bannerDivElement).backgroundImage;

    if (bannerBackgroundImage === 'none') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefBanner.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefTitle.current.defaultValue === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefTitle.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (fieldsInputRefSubtitle.current.defaultValue === '') {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${fieldsInputRefSubtitle.current.id} é obrigatório`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      linkInputFacebook.current.value != '' &&
      !linkInputFacebook.current.value.includes('facebook.com')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${linkInputFacebook.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      linkInputInstagram.current.value != '' &&
      !linkInputInstagram.current.value.includes('instagram.com')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${linkInputInstagram.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      linkInputTwitter.current.value != '' &&
      !linkInputTwitter.current.value.includes('twitter.com')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${linkInputTwitter.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      linkInputYoutube.current.value != '' &&
      !linkInputYoutube.current.value.includes('youtube.com')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${linkInputYoutube.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else if (
      linkInputLinkedin.current.value != '' &&
      !linkInputLinkedin.current.value.includes('linkedin.com')
    ) {
      toast({
        position: 'top',
        description: `O preenchimento do campo: ${linkInputLinkedin.current.id} está incorreto`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    } else {
      handlePutWebsite();
      navigate(`/corretor/white-label/step-five/${idWebsite}/`);
    }
  };

  useEffect(() => {
    handleGetWebsite();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    listAllImages().then((imagens) => {
      setCorretorImages(imagens);
    });
  }, []);

  return (
    <>
      <WhiteLabelWrapper>
        <Box p="40px 56px">
          <VStack gap="30px">
            <HStack
              w="100%"
              display="flex"
              justifyContent="space-between"
              alignItems="start"
            >
              <Box>
                <Heading
                  fontSize="2rem"
                  fontWeight="700"
                  lineHeight="3rem"
                  color="#000000"
                >
                  Configuração do site
                </Heading>
                <Text
                  mt="10px"
                  maxW="541px"
                  fontSize="1rem"
                  fontWeight="400"
                  lineHeight="1.5rem"
                  color="#323232"
                >
                  Você pode inserir mais uma sessão de imagem e texto em seu
                  site, inserir redes sociais ou clique em “Salvar e continuar”
                  para publicar seu site.
                </Text>
              </Box>
              <WhiteLabelSteps currentStep={4} />
            </HStack>
            <Stack
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px"
            >
              <Heading
                fontSize="1.5rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#001E64"
              >
                Seção 2
              </Heading>
              <Text
                id="bannerStepFour"
                marginTop="20px"
                fontSize="1.25rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
              >
                Agora vamos adicionar seu banner
              </Text>
              <Box
                marginTop="10px"
                width="100%"
                fontWeight="400"
                fontSize="1rem"
                lineHeight="1.5rem"
                color="#323232"
                display="inline-block"
              >
                <Box>
                  <Text display="inline-block">
                    Sua imagem deve conter&nbsp;
                  </Text>
                  <Text display="inline-block" fontWeight="700">
                    800px de largura por 360px de altura.
                  </Text>
                </Box>
                <Box>
                  <Text display="inline-block">formato suportado&nbsp;</Text>
                  <Text display="inline-block" fontWeight="700">
                    JPEG ou PNG.
                  </Text>
                </Box>
              </Box>
              <VStack
                marginTop="20px !important"
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px"
                divider={
                  <StackDivider
                    border="1px solid #D2D2D2"
                    margin="0px !important"
                  />
                }
              >
                <HStack width="100%" marginBottom="30px !important">
                  <Stack>
                    <Box
                      id="Agora vamos adicionar seu banner"
                      ref={fieldsInputRefBanner}
                      bg={
                        state.selectedFileBannerFour
                          ? `url(${state.selectedFileBannerFour})`
                          : state.selectedFileBannerFourName
                          ? `url(${state.selectedFileBannerFourName})`
                          : '#FFFFFF'
                      }
                      backgroundPosition="center"
                      backgroundRepeat="no-repeat"
                      backgroundSize="cover"
                      width="204px"
                      height="210px"
                      borderRadius="14px"
                      border={
                        // isDragBannerFour
                        //   ? '1px dashed #FF5000'
                        //   :
                        '1px dashed #AAAAAA'
                      }
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      // onDragLeave={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBannerFour(false);
                      // }}
                      // onDragOver={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBannerFour(true);
                      // }}
                      // onDrop={(e) => {
                      //   e.preventDefault(), e.stopPropagation();
                      //   setIsDragBannerFour(false);
                      //   handleURLImageBannerFour(e);
                      // }}
                    >
                      <Text
                        fontSize="1rem"
                        fontWeight="400"
                        lineHeight="1.5rem"
                        color="#5A5A5A"
                        textAlign="center"
                      >
                        {!hasBanner ? 'Sua imagem aparecerá aqui' : undefined}
                      </Text>
                    </Box>
                    <Text
                      marginTop="10px"
                      marginBottom="30px"
                      fontSize="0.875rem"
                      lineHeight="1.5rem"
                      fontWeight="400"
                      color="#000000"
                    >
                      Tamanho maximo permetido: 5MB
                    </Text>
                  </Stack>
                  <Box>
                    <Button
                      id="openUpload"
                      onClick={() => setIsOpenModal(true)}
                      marginLeft="30px !important"
                      marginRight="21px !important"
                      background="transparent"
                      width="282px"
                      height="48px"
                      padding="13px 48px"
                      border="1px solid #FF5000"
                      borderRadius="133.5px"
                      color="#FF5000"
                      fontWeight="700"
                      fontSize="1rem"
                      lineHeight="22px"
                      gap="15px"
                      _hover={{ background: '#ffff' }}
                      _focus={{
                        '&:focus': {
                          boxShadow: 'none !important'
                        }
                      }}
                      _active={{}}
                    >
                      <UploadIcon width="1rem" height="1rem" />
                      Escolher sua imagem
                    </Button>
                  </Box>
                  {/* <Text
                    margin="0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {state.selectedFileBannerFour === null
                      ? 'Nenhum item selecionado'
                      : state.selectedFileBannerFour === ''
                      ? 'Nenhum item selecionado'
                      : nameImgBannerFour}
                  </Text> */}
                </HStack>
                {/* <HStack
                  width="100%"
                  marginTop="30px !important"
                  display="inline-block"
                >
                  <Box width="483px" height="64px" marginBottom="20px">
                    <Text
                      fontSize="1.25rem"
                      lineHeight="2rem"
                      fontWeight="700"
                      color="#000000"
                    >
                      Caso você não tiver uma imagem você pode escolher uma
                      através do nosso banco de imagens
                    </Text>
                  </Box>
                  <Button
                    margin="0 !important"
                    background="#FFFFFF"
                    width="290px"
                    height="48px"
                    padding="13px 48px"
                    border="1px solid #FF5000"
                    borderRadius="133.5px"
                    color="#FF5000"
                    fontWeight="700"
                    fontSize="1rem"
                    lineHeight="22px"
                    gap="15px"
                    _hover={{}}
                    _focus={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    _active={{}}
                    onClick={handleModalSelectImage}
                  >
                    Acessar banco de imagens
                  </Button>
                </HStack> */}
              </VStack>
              {criticalGecad.IMAGEM_SECAO_2 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.IMAGEM_SECAO_2}
                />
              ) : undefined}

              <Text
                id="titleStepFour"
                margin="30px 0 20px 0 !important"
                fontSize="1.25rem"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
                display="flex"
                alignItems="center"
                gridGap="10px"
              >
                Escreva um TÍTULO para complementar o seu SEGUNDO Banner*
                <Tooltip
                  hasArrow
                  m="0 0 5px 0!important"
                  label="Este texto acompanhará o seu segundo Banner como mensagem principal do site"
                  bg="gray.200"
                  placement="top-start"
                  color="#323232"
                >
                  <QuestionOutlineIcon />
                </Tooltip>
              </Text>
              <VStack
                margin="0px !important"
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px 30px 59px 30px"
              >
                <Stack textAlign="end" width="100%">
                  <Textarea
                    id="Escreva um TÍTULO para complementar o seu SEGUNDO Banner"
                    ref={fieldsInputRefTitle}
                    value={state.companyTitleFour}
                    resize="none"
                    placeholder="Incluir texto"
                    height="172px"
                    borderRadius="6px"
                    background="#FFFFFF"
                    border="1px solid #001E64 !important"
                    padding="20px"
                    _hover={{}}
                    _focus={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    _active={{}}
                    _placeholder={{
                      fontSize: '1rem',
                      color: '#828282',
                      fontWeight: '400',
                      lineHeight: '1.5rem'
                    }}
                    onChange={(event) => {
                      setState({
                        type: StepsFormActions.setCompanyTitleFour,
                        payload: event.target.value
                      });
                      setDescriptionTitleLength(event.target.value.length);
                    }}
                    maxLength={100}
                  />
                  <Text
                    margin="5px 0 0 0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {descriptionTitleLength}/100 caracteres
                  </Text>
                </Stack>
              </VStack>
              {criticalGecad.TITULO_SECAO_2 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.TITULO_SECAO_2}
                />
              ) : undefined}
              <Text
                margin="30px 0 20px 0 !important"
                fontSize="1.25rem"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
                display="flex"
                alignItems="center"
                gridGap="10px"
              >
                Escreva um SUBTÍTULO para complementar o seu SEGUNDO Banner*
                <Tooltip
                  hasArrow
                  m="0 0 5px 0!important"
                  label="Este texto acompanhará o seu segundo Banner como mensagem secundária do site"
                  bg="gray.200"
                  placement="top-start"
                  color="#323232"
                >
                  <QuestionOutlineIcon />
                </Tooltip>
              </Text>
              <VStack
                margin="0px !important"
                width="100%"
                borderRadius="15px"
                background="#F4F4F4"
                padding="30px 30px 59px 30px"
              >
                <Stack textAlign="end" width="100%">
                  <Textarea
                    id="Escreva um SUBTÍTULO para complementar o seu SEGUNDO Banner"
                    ref={fieldsInputRefSubtitle}
                    value={state.companySubtitleFour}
                    resize="none"
                    placeholder="Incluir texto"
                    height="172px"
                    borderRadius="6px"
                    background="#FFFFFF"
                    border="1px solid #001E64 !important"
                    padding="20px"
                    _hover={{}}
                    _focus={{
                      '&:focus': {
                        boxShadow: 'none !important'
                      }
                    }}
                    _active={{}}
                    _placeholder={{
                      fontSize: '1rem',
                      color: '#828282',
                      fontWeight: '400',
                      lineHeight: '1.5rem'
                    }}
                    onChange={(event) => {
                      setState({
                        type: StepsFormActions.setCompanySubtitleFour,
                        payload: event.target.value
                      });
                      setdescriptionSubTitleLength(event.target.value.length);
                    }}
                    maxLength={200}
                  />
                  <Text
                    margin="5px 0 0 0 !important"
                    fontSize="0.875rem"
                    fontWeight="400"
                    lineHeight="1.5rem"
                    color="#000000"
                  >
                    {descriptionSubTitleLength}/200 caracteres
                  </Text>
                </Stack>
              </VStack>
              {criticalGecad.SUBTITULO_SECAO_2 ? (
                <BoxCritical
                  maxWidth={'416px'}
                  textContent={criticalGecad.SUBTITULO_SECAO_2}
                />
              ) : undefined}
            </Stack>
            <Stack
              margin="30px 0 0 0"
              background="#FFFFFF"
              width="100%"
              boxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              borderRadius="24px"
              padding="30px"
            >
              <Heading
                fontSize="1.5rem"
                fontWeight="700"
                lineHeight="2rem"
                color="#001E64"
              >
                Rodapé
              </Heading>
              <Text
                id="footerStepFour"
                marginTop="20px !important"
                fontSize="1.25rem"
                fontStyle="normal"
                fontWeight="700"
                lineHeight="2rem"
                color="#323232"
              >
                Agora vamos adicionar suas redes sociais
              </Text>
              <Text
                marginTop="10px !important"
                maxWidth="573px"
                fontWeight="400"
                fontSize="1rem"
                lineHeight="1.5rem"
                color="#323232"
                display="inline-block"
              >
                Preencha os detalhes da sua conta para outros sites que você usa
                e os exibiremos em seu perfil. Os que você deixar em branco não
                serão exibidos.
              </Text>
              <VStack marginTop="30px !important" display="inline-block">
                <SocialMediaRow
                  linkInputFacebook={linkInputFacebook}
                  criticaFacebook={criticalGecad.FACEBOOK}
                  linkInputInstagram={linkInputInstagram}
                  criticaInstagram={criticalGecad.INSTAGRAM}
                  linkInputTwitter={linkInputTwitter}
                  criticaTwitter={criticalGecad.TWITTER}
                  linkInputYoutube={linkInputYoutube}
                  criticaYoutube={criticalGecad.YOUTUBE}
                  linkInputLinkedin={linkInputLinkedin}
                  criticaLinkedin={criticalGecad.LINKEDIN}
                />
              </VStack>
            </Stack>
            <WhiteLabelNavigator
              hrefPrev={`/corretor/white-label/step-two/${idWebsite}`}
              nextAction={(e: any) => {
                handleSubmit(e);
              }}
              btnNextText={'Salvar e Concluir'}
            />
          </VStack>
        </Box>
      </WhiteLabelWrapper>
      <ModalSelectImage
        images={corretorImages}
        isOpenModal={isOpenModal}
        handleModalSelectImage={handleModalSelectImage}
        handleImageSelectedGalleryBanner={handleImageSelectedGalleryBannerFour}
      />
    </>
  );
};
